import { UnknownAction, Reducer, ReducersMapObject } from 'redux';
import update from 'immutability-helper';
import { AppState } from './store';

export const combineReducersWithRoot = (
  rootReducer: Reducer<AppState | undefined, UnknownAction>,
  reducers: ReducersMapObject<any, UnknownAction>
) => {
  return (state: AppState | undefined, action: UnknownAction): AppState => {
    const rootState = rootReducer(state, action);
    let newState = rootState || ({} as any);
    (Object.keys(reducers) as (keyof AppState)[]).forEach((domain) => {
      const obj = rootState && rootState[domain] ? rootState[domain] : undefined;
      newState = update(newState, {
        [domain]: { $set: reducers[domain](obj, action) },
      });
    });
    return newState;
  };
};
